/**
 * Dizionario fr.
 *
 * Francese (Fase 2): mercato e lingua dei clienti delle case italiane.
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua. Aggiungere una lingua è quindi un file nuovo qui
 * più il codice in `APP_LOCALES`, non una modifica a `i18n.jsx`.
 */
export default {
  "nav": {
    "showcase": "Vitrine",
    "directory": "Hébergements",
    "network": "Réseau",
    "pricing": "Tarifs",
    "login": "Connexion",
    "signup": "Inscrire l'hébergement",
    "dashboard": "Tableau de bord",
    "logout": "Déconnexion",
    "book": "Réserver",
    "host_area": "Je gère un hébergement",
    "find_stay": "Trouver un séjour",
    "bedbank": "Bedbank",
    "claim": "Revendiquer",
    "affiliates": "Affiliés",
    "merchant_area": "Espace commerçant",
    "merchants": "Commerçants",
    "merchant_login": "Accès commerçants",
    "merchant_login_title": "Je gère un commerce local",
    "merchant_space": "Espace commerçants",
    "host_dashboard": "Tableau de bord hôte",
    "account": "Compte",
    "language": "Langue"
  },
  "landing": {
    "eyebrow": "Plateforme pour les hébergements",
    "title1": "L'hospitalité italienne,",
    "title2": "dans le monde.",
    "subtitle": "Faites connaître votre hébergement, synchronisez les OTA, échangez des chambres avec des partenaires de confiance. Une maison numérique pour les chambres d'hôtes, les gîtes et les hôtels.",
    "cta_primary": "Commencer gratuitement",
    "cta_secondary": "Voir les vitrines",
    "f1_title": "Une vitrine en sept langues",
    "f1_body": "Une page publique en italien, anglais, espagnol, français, allemand, portugais et grec qui raconte votre hébergement. Photos, chambres, réservation directe avec Stripe.",
    "f2_title": "Réseau entre hébergements",
    "f2_body": "Surbooké ? Orientez le client vers un partenaire. Marché national + groupes fermés locaux.",
    "f3_title": "Demandes de groupe",
    "f3_body": "Publiez une demande pour un groupe nombreux : les hébergements voisins répondent. Petit-déjeuner centralisé inclus.",
    "f4_title": "Calendrier unique",
    "f4_body": "Réservations directes, chambres du réseau, OTA synchronisées via iCal (à venir). Zéro surbooking.",
    "f5_title": "PMS inclus",
    "f5_body": "Un véritable Property Management System dans la plateforme : front office, réception, ménage, cuisine, achats et journal des opérations. Aucun logiciel supplémentaire à payer.",
    "showcase_title": "Hébergements en vitrine",
    "showcase_sub": "Quelques-unes des maisons qui se racontent sur Hostaly.",
    "how_title": "Comment ça marche",
    "how_1": "Inscrivez votre hébergement",
    "how_1b": "Inscription en 60 secondes. Vérification automatique pour le MVP.",
    "how_2": "Configurez la vitrine en sept langues",
    "how_2b": "Des textes pour chaque langue, photos, services, chambres. Publiez quand vous êtes prêt.",
    "how_3": "Rejoignez le réseau",
    "how_3b": "Proposez des chambres de dernière minute, répondez aux demandes de groupe, recevez vos paiements.",
    "final_title": "La maison numérique des hébergements",
    "final_body": "Une seule plateforme pour gérer la vitrine, le réseau et les réservations."
  },
  "auth": {
    "login": "Connexion",
    "register": "Inscrire votre hébergement",
    "email": "E-mail",
    "password": "Mot de passe",
    "structure": "Nom de l'hébergement",
    "country": "Pays de l'hébergement",
    "country_help": "Il détermine les obligations qui vous concernent. Ce n'est pas la langue de l'interface : celle-ci se choisit séparément.",
    "cin_label": "Code CIN",
    "cin_help": "Code d'identification national MITUR — obligatoire par la loi (DL 145/2023). Format national : IT + 15 caractères (17 au total). Certaines régions comme la Sicile peuvent utiliser des formats plus longs (jusqu'à 22 caractères). Demandez-le sur bdsr.ministeroturismo.gov.it",
    "cin_not_required": "Hors d'Italie, le CIN n'est pas nécessaire : nous vous demanderons votre numéro d'enregistrement local le moment venu.",
    "submit_login": "Entrer",
    "submit_register": "Créer le compte",
    "aff_rules": "Règles d'affiliation",
    "aff_consent": "Je déclare avoir lu et accepté les",
    "aff_consent_hint": "Obligatoire pour inscrire l'hébergement : couvre les commissions, les paiements, les obligations de l'hébergement et toutes les promotions prévues par le contrat (clause 6.4).",
    "switch_to_register": "Pas de compte ? Inscrivez l'hébergement",
    "switch_to_login": "Vous avez déjà un compte ? Connectez-vous",
    "forgot": "Mot de passe oublié ?",
    "demo_hint": "Démo : demo@hospitalityhub.it / demo1234",
    "staff_title": "Créez votre compte",
    "staff_hint": "Le titulaire de l'hébergement vous a attribué un rôle. Utilisez exactement l'adresse e-mail qu'il a utilisée : c'est elle qui relie votre compte au rôle.",
    "staff_name": "Nom et prénom",
    "staff_name_help": "Facultatif. Cela sert seulement à ce que vos collègues vous reconnaissent.",
    "role_label": "Votre rôle dans l'hébergement",
    "role_general_manager": "General Manager (propriétaire)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Opérateur (ménage/cuisine/réparations)",
    "role_help": "Détermine ce que vous pouvez faire dans la Gestion Hôtelière. Le General Manager gère les rôles du personnel.",
    "staff_password_hint": "Au moins 8 caractères.",
    "staff_submit": "Créer mon compte",
    "account_created": "Compte créé",
    "welcome_back": "Bon retour",
    "cin_invalid": "Code CIN invalide. Il doit commencer par 'IT' suivi de 14 à 20 caractères alphanumériques.",
    "cin_title": "Commence par IT + 14-20 caractères (16-22 au total, ex. Sicile 18)",
    "aff_required": "Vous devez prendre connaissance des Règles d'affiliation pour continuer.",
    "google": "Continuer avec Google",
    "apple": "Continuer avec Apple",
    "soon": "bientôt",
    "google_unavailable": "Connexion Google indisponible",
    "google_not_configured": "La connexion Google n'est pas configurée sur cette installation. Utilisez e-mail et mot de passe ; la clé (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) doit être ajoutée sur le serveur.",
    "apple_failed": "Échec de la connexion Apple",
    "contract_docx": "Télécharger le contrat complet (DOCX)",
    "costs_title": "Ce que Hostaly vous coûte",
    "costs_body": "Aucun frais d'inscription. La commission s'applique à chaque réservation et baisse avec le forfait.",
    "to_staff": "Un rôle vous a été attribué dans un hébergement ? Créez le compte ici",
    "host_plans": "Forfaits hôtes",
    "pick_plan": "Choisissez le forfait qu'il vous faut"
  },
  "dash": {
    "welcome": "Bienvenue,",
    "overview": "Aperçu",
    "property": "Hébergement",
    "rooms": "Chambres",
    "bookings": "Réservations",
    "marketplace": "Réseau",
    "groups": "Demandes de groupe",
    "reviews": "Avis",
    "ical": "Synchro OTA",
    "swaps": "Échanges",
    "breakfast": "Petit-déjeuner",
    "total_bookings": "Réservations totales",
    "revenue": "Revenus",
    "open_offers": "Offres ouvertes",
    "published": "Publié",
    "not_published": "Non publié",
    "publish": "Publier la vitrine",
    "unpublish": "Masquer la vitrine",
    "view_showcase": "Voir la vitrine publique",
    "copy_link": "Copier le lien",
    "copied": "Copié !",
    "save": "Enregistrer",
    "saved": "Enregistré",
    "name": "Nom",
    "city": "Ville",
    "region": "Région",
    "address": "Adresse",
    "country": "Pays",
    "country_help": "Où se trouve le bien : c'est de là que viennent les identifiants et les échéances que nous vous montrons.",
    "locality": "Commune / localité",
    "currency": "Devise",
    "currency_help": "La devise du pays. Les prix des chambres et les débits restent en euros : le site convertit uniquement pour l'affichage.",
    "obligations_title": "Obligations du pays",
    "obligations_hint": "Ce qu'il faut déclarer, à qui et dans quel délai. La liste suit le pays de l'hébergement : changez de pays et les obligations changent.",
    "obligations_active": "Actif",
    "obligations_toggle": "Marquer comme actif",
    "obligations_source": "Source officielle",
    "obligations_verified": "Vérifié le",
    "obligations_error": "Je n'arrive pas à enregistrer l'obligation",
    "timezone": "Fuseau horaire",
    "phone": "Téléphone",
    "desc_it": "Description (IT)",
    "desc_en": "Description (EN)",
    "amenities": "Services (séparés par une virgule)",
    "hero_image": "Photo principale",
    "photos": "Galerie photo",
    "property_type": "Type d'hébergement",
    "add_room": "Ajouter une chambre",
    "room_name": "Nom de la chambre",
    "price_night": "Prix/nuit (€)",
    "capacity": "Capacité",
    "photo_url": "URL de la photo",
    "publish_offer": "Mettre sur le réseau",
    "no_bookings": "Aucune réservation pour l'instant",
    "no_rooms": "Aucune chambre. Ajoutez-en une pour commencer.",
    "offer_from": "Du",
    "offer_to": "Au",
    "post_group_req": "Publier une demande de groupe",
    "title": "Titre",
    "guests": "Personnes",
    "budget": "Budget/nuit (€)",
    "notes_it": "Notes (IT)",
    "notes_en": "Notes (EN)",
    "respond": "Répondre",
    "rooms_offered": "Chambres proposées",
    "message": "Message",
    "send": "Envoyer la réponse",
    "responses": "réponses",
    "total": "Total",
    "night": "nuit",
    "nights": "nuits",
    "upload_photo": "Téléverser une photo",
    "uploading": "Téléversement...",
    "drop_here": "Glissez ou cliquez pour téléverser",
    "remove": "Retirer",
    "ical_title": "Synchronisez les OTA via iCal",
    "ical_sub": "Importez les disponibilités et les réservations de Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "URL iCal",
    "ical_source": "Plateforme",
    "ical_import": "Importer",
    "ical_last_sync": "Dernière synchro",
    "ical_events": "Événements importés",
    "calendar_unified": "Calendrier unifié",
    "swap_forward": "Transférer à un partenaire",
    "swap_title": "Échange de chambre",
    "partner_property": "Hébergement partenaire",
    "partner_room": "Chambre partenaire",
    "commission_10": "Une commission de 10 % sera retenue",
    "swap_notes": "Notes pour le partenaire",
    "swap_send": "Proposer l'échange",
    "no_swaps": "Aucun échange pour l'instant",
    "breakfast_title": "Petit-déjeuner centralisé",
    "breakfast_sub": "Proposez ou réservez des petits-déjeuners pour les clients du réseau.",
    "add_breakfast_slot": "Nouveau service petit-déjeuner",
    "slot_date": "Date",
    "slot_time": "Heure",
    "slot_max": "Couverts maximum",
    "slot_price": "Prix/couvert (€)",
    "book_covers": "Réserver des couverts",
    "covers": "couverts",
    "book_slot": "Réserver",
    "available": "disponibles",
    "your_breakfast_bookings": "Vos réservations de petit-déjeuner",
    "role": "Rôle",
    "date": "Date",
    "amount": "Montant",
    "source": "Origine",
    "event_title": "Titre",
    "start": "Début",
    "end": "Fin",
    "no_events": "Aucun événement — importez un iCal ou recevez une réservation.",
    "welcome_back": "Bon retour",
    "toast_uploaded": "Téléversé",
    "toast_upload_failed": "Échec du téléversement",
    "toast_error": "Erreur",
    "toast_swap_sent": "Échange proposé · client prévenu",
    "toast_slot_added": "Service ajouté",
    "toast_slot_booked": "Réservé",
    "toast_offer_posted": "Offre publiée",
    "toast_gr_posted": "Demande publiée",
    "toast_response_sent": "Réponse envoyée",
    "toast_imported": "{n} événements importés",
    "select_room": "Choisir une chambre",
    "select_partner": "Choisir un partenaire",
    "select_booking": "Choisir une réservation",
    "no_paid_bookings": "Aucune réservation payée",
    "per_cover": "par couvert",
    "outgoing": "sortant",
    "incoming": "entrant",
    "from_label": "Du :",
    "to_label": "Au :",
    "commission_10pct": "Commission (10 %)",
    "analytics": "Analytique",
    "revenue_monthly": "Revenus mensuels",
    "direct_bookings": "Réservations directes",
    "swap_commissions": "Commissions d'échange",
    "breakfast_income": "Revenus petit-déjeuner",
    "no_analytics": "Pas encore de données — commencez à recevoir des réservations.",
    "stripe_connect": "Versements automatiques",
    "connect_start": "Activer Stripe Connect",
    "connect_continue": "Terminer l'inscription",
    "connect_done": "Versements actifs",
    "connect_pending": "Inscription en cours",
    "connect_hint": "Recevez automatiquement les réservations directes nettes de la commission Hostaly (8 % Base · 6 % Pro · 4,5 % Enterprise). Les frais Stripe de traitement des paiements sont à la charge du compte connecté.",
    "accept_split": "Accepter et répartir",
    "select_partners": "Choisir les partenaires",
    "allocated_rooms": "Chambres attribuées",
    "allocation_confirmed": "Répartition confirmée",
    "push_title": "Notifications du navigateur",
    "push_hint": "Recevez une alerte sur votre appareil même onglet fermé.",
    "push_enable": "Activer les notifications",
    "push_disable": "Désactiver",
    "push_on": "Activées",
    "push_off": "Désactivées",
    "push_denied": "Bloquées par le navigateur",
    "instagram": "Instagram",
    "ig_handle": "Compte Instagram (@)",
    "ig_posts": "Publications récentes",
    "ig_add": "Ajouter une publication",
    "ig_image": "URL de l'image",
    "ig_caption": "Légende",
    "ig_link": "Lien de la publication",
    "verification": "Vérification",
    "verify_title": "Vérification de l'hébergement",
    "verify_hint": "Les hébergements vérifiés affichent le badge ✓ sur le marché et sur la vitrine.",
    "verified": "Vérifié",
    "pending_verify": "En attente",
    "not_verified": "Non vérifié",
    "submit_verify": "Demander la vérification",
    "vat_number": "Numéro de TVA",
    "business_name": "Raison sociale",
    "municipality": "Commune",
    "declaration": "Je déclare sous ma responsabilité que ces données sont exactes",
    "admin": "Administration",
    "admin_pending": "Demandes en attente",
    "approve": "Approuver",
    "reject": "Refuser",
    "admin_note": "Note interne",
    "ai_copy": "Générer avec l'IA",
    "ai_copy_title": "Générer la vitrine avec l'IA",
    "ai_copy_hint": "Saisissez quelques mots-clés — l'IA créera la description IT/EN et les services.",
    "ai_keywords": "Mots-clés (séparés par une virgule)",
    "ai_tone": "Ton",
    "ai_generate": "Générer",
    "ai_apply": "Appliquer à la vitrine",
    "promo_code": "Code de réduction",
    "promo_apply": "Appliquer",
    "promo_valid": "Code valide",
    "promo_saved": "Vous économisez",
    "trade_nav": "Trade B2B",
    "trade_title": "Vente B2B pour tour-opérateurs et agences",
    "trade_sub": "Achetez des blocs de chambres directement auprès des hébergements italiens à tarifs réservés.",
    "trade_offers": "Offres trade",
    "trade_login": "Connexion trade",
    "trade_register": "Inscrire une agence",
    "trade_company": "Nom de l'agence / tour-opérateur",
    "trade_vat": "Numéro de TVA",
    "trade_country": "Pays",
    "trade_publish": "Publier l'offre trade",
    "trade_new_offer": "Nouvelle offre trade",
    "trade_rooms_available": "Chambres disponibles",
    "trade_price_per_night": "Prix/chambre/nuit (€)",
    "trade_min_nights": "Nuits minimum",
    "trade_buy": "Acheter maintenant",
    "trade_orders_mine": "Mes réservations",
    "trade_sold": "vendues",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "Canaux OTA",
    "b2b_title": "Canal B2B · bedbank",
    "b2b_subtitle": "Achetez des tarifs nets à un bedbank, appliquez votre marge et reversez la commission au partenaire.",
    "b2b_suppliers": "Fournisseurs",
    "b2b_add_supplier": "Ajouter un fournisseur",
    "b2b_mapping": "Mapping hôtel",
    "b2b_rules": "Règles de prix",
    "b2b_simulator": "Simulateur",
    "b2b_settlements": "Règlements",
    "b2b_net": "Tarif net",
    "b2b_nights": "Nuits",
    "b2b_markup": "Marge",
    "b2b_rebate": "Reversement",
    "b2b_msp": "Prix minimum (MSP)",
    "b2b_gross": "Prix public",
    "b2b_charged": "Encaissé immédiatement",
    "b2b_margin": "Marge",
    "b2b_blocked": "Non vendable",
    "b2b_msp_binding": "Prix bloqué par le minimum du fournisseur",
    "b2b_cashback": "Le reversement arrive après la réservation",
    "b2b_needed_markup": "Marge nécessaire",
    "b2b_target_margin": "Marge visée",
    "b2b_credentials_missing": "Identifiants manquants",
    "b2b_confirmed_by": "Confirmé par",
    "b2b_auto": "Associé automatiquement",
    "b2b_review": "À confirmer",
    "b2b_no_candidates": "Aucun candidat compatible",
    "b2b_partners": "Contreparties",
    "b2b_add_partner": "Ajouter une contrepartie",
    "b2b_partner_kind": "Type",
    "b2b_partner_agency": "Agence",
    "b2b_partner_tour_operator": "Tour-opérateur",
    "b2b_partner_hotel": "Autre hôtel",
    "b2b_partner_vat": "Numéro de TVA",
    "b2b_payment_terms": "Conditions de paiement",
    "b2b_credit_risk": "Risque d'impayé",
    "b2b_credit_limit": "Encours autorisé",
    "b2b_terms_agency": "Agences et autres hôtels : aucun encaissement auprès des consommateurs, donc pas de paiement par carte.",
    "b2b_outstanding": "À régler",
    "b2b_rates": "Tarifs par contrepartie",
    "b2b_net_rate": "Tarif net",
    "b2b_public_price": "Prix de la vitrine",
    "b2b_above_public": "Au-dessus du prix de la vitrine",
    "b2b_above_public_hint": "Vous demandez à la contrepartie plus que ce que vous demandez à un client venant de la vitrine. L'agence le remarque et vous contourne."
  },
  "vetrina": {
    "book": "Réserver",
    "from": "à partir de",
    "per_night": "/ nuit",
    "rooms": "Chambres",
    "reviews": "Avis",
    "contact": "Contact",
    "leave_review": "Laisser un avis",
    "guest_name": "Votre nom",
    "rating": "Note",
    "comment": "Votre commentaire",
    "submit": "Envoyer l'avis",
    "services": "Services",
    "check_in": "Arrivée",
    "check_out": "Départ",
    "guest_email": "Votre e-mail",
    "confirm_book": "Confirmer et payer",
    "total_price": "Total",
    "processing": "Traitement...",
    "book_this_room": "Réserver cette chambre",
    "promo_code": "Code de réduction",
    "promo_apply": "Appliquer",
    "promo_valid": "Code valide",
    "promo_saved": "Vous économisez",
    "traveller_nudge": "Vous êtes voyageur ?",
    "prefill_login": "Connectez-vous pour préremplir vos informations →",
    "beds": "Lits",
    "beds_hint": "Prix par lit : {count} lits disponibles dans ce dortoir.",
    "phone": "Téléphone",
    "phone_optional": "Téléphone (facultatif)",
    "phone_placeholder": "+33 6 12 34 56 78",
    "phone_hint": "L'hôte ne l'utilisera que pour vous contacter au sujet de cette réservation.",
    "charged_in": "Débit en {currency} · {amount}",
    "fx_note": "Taux BCE : 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "dernier taux disponible",
    "pay_now": "Payer maintenant",
    "pay_now_hint": "Carte · débit immédiat",
    "pay_at_property": "Payer sur place",
    "pay_at_property_hint": "Carte en garantie · débit uniquement en cas de no-show",
    "pay_at_hotel": "Payer à l'hôtel",
    "pay_at_hotel_hint": "Tout payer à l'arrivée · carte en garantie requise",
    "pay_at_hotel_title": "Tout payer à l'arrivée, sur place",
    "pay_at_hotel_step1": "Aucun débit maintenant : vous réglez le séjour complet à l'arrivée, directement à l'hôtel.",
    "pay_at_hotel_step2": "Une carte de crédit valide est requise pour garantir la réservation. Elle n'est pas débitée aujourd'hui : nous la conservons uniquement à titre de garantie.",
    "pay_at_hotel_step3": "La carte n'est débitée qu'en cas de no-show ou d'annulation hors délai, selon la politique de l'hôtel.",
    "pay_at_hotel_total": "Total à payer sur place",
    "pay_at_hotel_continue": "Continuer avec la carte en garantie",
    "pay_at_hotel_unavailable": "La garantie par carte n'est pas disponible pour le moment : réservez avec le paiement par carte ou contactez l'hôtel.",
    "paypal_hint": "Payez avec votre compte PayPal",
    "pay_with_paypal": "Payer avec PayPal",
    "paypal_note": "Vous serez redirigé vers PayPal pour finaliser le paiement en toute sécurité, puis vous reviendrez ici.",
    "redirecting": "Redirection…",
    "enter_email_code": "Saisissez email et code",
    "invalid_code": "Code invalide",
    "phone_invalid": "Saisissez un numéro de téléphone valide",
    "name_email_required": "Nom et email obligatoires",
    "pick_dates": "Choisissez vos dates",
    "accept_policy": "Vous devez accepter la politique no-show pour continuer",
    "report_content": "Signaler un contenu",
    "guest_terms": "Conditions de réservation",
    "free_cancel": "Annulation gratuite",
    "no_show_policy": "Politique no-show",
    "penalty": "Pénalité",
    "free_cancel_note": "Annulation gratuite jusqu'à {days} jours avant l'arrivée.",
    "free_cancel_note_one": "Annulation gratuite jusqu'à 1 jour avant l'arrivée.",
    "by_date": "Avant le {date}.",
    "then_retained": "Ensuite, {percent}% est retenu.",
    "penalty_note": "Annulation soumise à une pénalité : {penalty}.",
    "first_night": "première nuit",
    "percent_of_total": "{percent}% du total",
    "guarantee_card": "Carte en garantie",
    "no_charge_note": "Aucun débit maintenant. Nous effectuons seulement une vérification temporaire de 1 € (libérée immédiatement) pour valider la carte.",
    "no_show_consent": "J'accepte qu'en cas de no-show après l'échéance, {amount} soit débité de la carte indiquée.",
    "confirm_no_charge": "Confirmer la réservation (sans débit)",
    "please_wait": "Veuillez patienter…",
    "booking_confirmed": "Réservation confirmée · Carte •••• {last4} enregistrée en garantie",
    "verified": "Vérifié",
    "guest_favourite": "Coup de cœur des voyageurs",
    "guest_favourite_hint": "Coup de cœur des voyageurs — décerné aux hébergements les plus appréciés",
    "rates_loading": "Chargement des taux...",
    "per_bed_night": "par lit / nuit",
    "dorm_badge": "Dortoir {gender} · {beds} lits",
    "floor": "Étage {number}",
    "free_cancel_badge": "Annulation gratuite jusqu'à {days} jours avant",
    "guest": "Voyageur",
    "thanks": "Merci !",
    "posting_as": "Vous publiez en tant que",
    "rating_5": "Parfait",
    "rating_4": "Bon",
    "rating_3": "Correct",
    "rating_2": "Insuffisant",
    "rating_1": "Très mauvais",
    "dictate_review": "Dicter votre avis",
    "gender_mixed": "mixte",
    "gender_female": "féminin",
    "gender_male": "masculin"
  },
  "guest": {
    "my_bookings": "Mes réservations",
    "my_maps": "Mes cartes",
    "travellers_area": "Espace voyageurs",
    "have_account": "Vous avez déjà un compte ?",
    "login": "Se connecter",
    "signup": "S'inscrire"
  },
  "pay": {
    "success": "Réservation confirmée",
    "success_body": "Vous recevrez un e-mail de confirmation. Merci !",
    "cancel": "Paiement annulé",
    "cancel_body": "Aucun débit n'a été effectué.",
    "back_home": "Retour à l'accueil",
    "checking": "Vérification du paiement..."
  },
  "common": {
    "close": "Fermer",
    "cancel": "Annuler",
    "loading": "Chargement...",
    "city": "Ville",
    "filter_city": "Filtrer par ville"
  },
  "trip_group": {
    "propose_title": "D'autres voyageurs à vos dates",
    "propose_caption": "Un groupe de voyageurs existe pour {from} → {until}. Vous pouvez le rejoindre, même juste pour discuter : aucune obligation de se déplacer ensemble.",
    "joined_title": "Vous êtes dans le groupe",
    "joined_caption": "Le chat du groupe est ouvert pendant les dates communes.",
    "join": "Rejoindre",
    "more": "Comment ça marche",
    "consent_note": "En rejoignant, vous activez le consentement aux groupes de voyageurs. Il est générique et révocable : aucune obligation de voyager ensemble.",
    "consent_enable": "Activer la participation",
    "optin_badge": "Voyageurs solo",
    "optin_title": "Vous voyagez seul ? D'autres vivent les mêmes expériences.",
    "optin_caption": "À vos dates, d'autres visitent, mangent et marchent là où vous allez : rejoignez le groupe et partagez seulement ce qui vous tente.",
    "optin_body": "L'adhésion ne se confirme qu'au moment du voyage et se retire quand vous voulez, sans conséquence sur la réservation.",
    "optin_on": "Adhésion active",
    "optin_off": "Je n'adhère pas",
    "optin_saved": "Préférence enregistrée. Vous pouvez la modifier quand vous voulez.",
    "optin_login": "Connectez-vous comme voyageur pour l'activer",
    "optin_error": "Impossible d'enregistrer la préférence.",
    "login_required": "Connectez-vous pour rejoindre le groupe.",
    "join_failed": "Je n'arrive pas à vous ajouter au groupe.",
    "cap_reached": "Vous êtes déjà dans 2 groupes qui se chevauchent : quittez-en un pour rejoindre celui-ci.",
    "tooltip_title": "Groupes de voyageurs",
    "tooltip_1": "On se regroupe par lieu et par période : un seul jour de séjour en commun suffit.",
    "tooltip_2": "Vous pouvez être dans plusieurs groupes, mais deux au maximum se chevauchent aux mêmes dates.",
    "tooltip_3": "Le chat est ouvert uniquement pendant les dates communes : les messages hors de ces dates n'arrivent pas.",
    "tooltip_4": "Les autres membres ne voient qu'un nom court, jamais les détails de votre réservation.",
    "tooltip_5": "Si vous annulez la réservation, vous quittez le groupe ; si vous restez le seul, le groupe se ferme.",
    "tooltip_window": "Période",
    "loading": "Chargement...",
    "back": "Retour",
    "chat_title": "Chat du groupe",
    "chat_hint": "Seuls les membres ayant des dates communes voient ces messages. Aucun détail de réservation n'est partagé.",
    "chat_failed": "Je n'arrive pas à charger le chat.",
    "send_failed": "Message non envoyé.",
    "chat_empty": "Écrivez un message.",
    "no_access": "Accès refusé",
    "no_access_detail": "Le chat est réservé aux membres ayant un séjour en commun et n'est ouvert que pendant les dates partagées.",
    "no_access_after_consent": "Le consentement est actif, mais vous ne faites pas partie de ce groupe : les dates ne coïncident plus, ou le groupe a fermé.",
    "not_found": "Groupe introuvable",
    "no_messages": "Aucun message pour l'instant. Lancez la conversation.",
    "new_message": "Nouveau message",
    "message_placeholder": "Écrivez quelque chose au groupe...",
    "send": "Envoyer",
    "cancel": "Annuler",
    "announce": "Annonce",
    "announcement": "Annonce",
    "meeting": "Rencontre",
    "meeting_proposal": "Proposition de rencontre",
    "new_meeting": "Proposer une rencontre",
    "meeting_when": "Quand",
    "meeting_when_placeholder": "ex. samedi matin",
    "meeting_when_required": "Indiquez quand.",
    "meeting_where": "Où",
    "meeting_where_placeholder": "ex. l'entrée du musée",
    "meeting_where_required": "Indiquez où.",
    "meeting_note": "Note (facultatif)",
    "meeting_note_placeholder": "Quelque chose à ajouter ?",
    "propose": "Proposer",
    "members": "Membres",
    "member_count": "Membres : {n}",
    "no_members": "Aucun membre pour l'instant.",
    "anonymous": "Invité",
    "chat_ok": "Dans le chat",
    "chat_no": "Groupe seulement"
  }
};
